import initialState from "./initialState";
import {
  FETCH_DETAIL_FATIGUE_INIT,
  FETCH_DETAIL_FATIGUE_SUCCESS,
  FETCH_DETAIL_FATIGUE_FAILURE,
  RESET_DETAIL_FATIGUE,
  SET_FILTER_DETAIL_FATIGUE
} from "../../actions/detail_fatigue/types";

export default function detailFatiga(state = initialState, action) {
  switch (action.type) {
    case FETCH_DETAIL_FATIGUE_INIT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DETAIL_FATIGUE_SUCCESS:
      return {
        ...state,
        datos: action.payload.data,
        error: null,
        loading: false,
        status: action.payload.status
      };
    case FETCH_DETAIL_FATIGUE_FAILURE:
      return {
        ...state,
        datos: {},
        error: action.payload,
        loading: false
      };
    case RESET_DETAIL_FATIGUE:
      return {
        ...state,
        datos: {},
        loading: true,
        error: null,
        status: null
      };
    case SET_FILTER_DETAIL_FATIGUE:
      return {
        ...state,
        filters: {
          date: {
            fechaStartFinal: action.payload.date.fechaStartFinal,
            fechaEndFinal: action.payload.date.fechaEndFinal
          },
          tags: action.payload.tags,
          hasRisk: action.payload.hasRisk
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/detail_fatigue/index.js